let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hhY0L")).then(() => parcelRequire('bBy4d'));